const _ = "adyen-pe-structured-list", S = `${_}__item`, L = `${_}__grid`, t = `${_}__content`, n = `${_}__label`, s = `${S}--has-highlight`;
export {
  _ as SL_BASE_CLASS,
  t as SL_CONTENT_CLASS,
  L as SL_GRID_CLASS,
  S as SL_ITEM_CLASS,
  s as SL_ITEM_WITH_HIGHLIGHT_CLASS,
  n as SL_LABEL_CLASS
};
